import React, { useContext, useState, useEffect } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { navigate } from '@reach/router';
import AppStateContext from '../../context/appStateContext';

import CustomerLogo from '../../../components/customerLogo';
import ButtonSmall from '../../../components/buttonSmall';
import NavTab from '../../../components/navTab';
import DialogLogout from '../Dialogs/dialogLogout';

import {
  BtmTabs,
  BtnOptionsCtn,
  BtnCtn,
  ContentCtn,
  LogAJobBtn,
  LogAJobBtnMobileCtn,
  LogoCtn,
  NavCtn,
  NavdropDown,
  NavdropDownDivider,
  NavdropDownTab,
  TabsCtn,
} from './index.style';

import ICONS from '../../../assets/icons';

const Nav: React.FC<any> = (): React.ReactElement => {
  const {
    currentPage,
    userPermissionsList,
    siteLogo,
    sharepointLink,
    setAppPageDetails,
    deleteUserRelatedState,
    resetContractDetails,
  } = useContext(AppStateContext);
  const [showLogout, setShowLogout] = useState(false);
  const [showNavDropdown, setNavDropdown] = useState(false);
  const [ logo, setLogo ] = useState('');
  const [ smallLogo, setSmallLogo ] = useState('');

  const setNav = (pageName: string) => {
    setNavDropdown(false);
    setAppPageDetails(pageName);
    navigate(`/app/${pageName}`);
  };

  const openSharepoint= () => {
    let sharepoint = window.open(sharepointLink, '_black');
    sharepoint.focus();
  };

  const resetDetails = () => {
    resetContractDetails();
  };

  useEffect(() => {
    setLogo(siteLogo['secondary_logos'][0]['image']['url']);
    setSmallLogo(siteLogo['small_logos'][0]['image']['url']);
  },[]);

  return (
    <React.Fragment>
      <NavCtn>
        <ContentCtn>
          {window.innerWidth >768 && <CustomerLogo />}
          <TabsCtn>
            <NavTab
              text="HOME"
              active={currentPage === 'home'}
              handleClick={(e): void => {
                e.preventDefault();
                setNav('home');
              }}
            >
              <ICONS.home />
            </NavTab>
            <NavTab
              text="REACTIVE MAINTENANCE"
              active={currentPage === 'reactiveMaintenance'}
              handleClick={(e): void => {
                e.preventDefault();
                setNav('reactiveMaintenance');
              }}
            >
              <ICONS.tool />
            </NavTab>
            <NavTab
              text="PLANNED PREVENTATIVE MAINTENANCE"
              active={currentPage === 'plannedMaintenance'}
              handleClick={(e): void => {
                e.preventDefault();
                setNav('plannedMaintenance');
              }}
            >
              <ICONS.clock />
            </NavTab>
            {userPermissionsList.includes('view-schedule') && <NavTab
              text="MAINTENANCE SCHEDULE"
              handleClick={(e): void => {
                e.preventDefault();
                setNav('maintenanceSchedule')
              }}
              active={currentPage === 'maintenanceSchedule'}
              sub={true}
            >
              <ICONS.calender/>
            </NavTab>}
            <NavTab
              text="ASSETS"
              active={currentPage === 'assets'}
              handleClick={(e): void => {
                e.preventDefault();
                setNav('assets');
              }}
            >
              <ICONS.box />
            </NavTab>
            <NavTab
              text="SHAREPOINT"
              hideOnMobile
              handleClick={(e): void => {
                e.preventDefault();
                openSharepoint();
              }}
            >
              <ICONS.externalLink />
            </NavTab>
            <NavTab
              text="MORE"
              hideOnDesktop
              active={showNavDropdown}
              handleClick={(e): void => {
                e.preventDefault();
                setNavDropdown(!showNavDropdown);
              }}
            >
              <ICONS.menu />
            </NavTab>
            {userPermissionsList.includes('log-a-job') && <LogAJobBtn
              type="button"
              onClick={(e): void => {
                e.preventDefault();
                setNav('logJob');
              }}
            >
              <div>LOG A JOB</div>
            </LogAJobBtn>}
          </TabsCtn>
          <BtmTabs>
            <NavTab
              text="SWITCH SITES"
              handleClick={(e): void => {
                e.preventDefault();
                setAppPageDetails('home');
                resetDetails();
                navigate('/app/selectContract');
              }}
            >
              <ICONS.user />
            </NavTab>
            <NavTab
              text="LOG OUT"
              handleClick={(e): void => {
                e.preventDefault();
                setShowLogout(true);
              }}
            >
              <ICONS.logOut />
            </NavTab>
          </BtmTabs>

          <LogoCtn logo={logo} smallLogo={smallLogo} />
        </ContentCtn>
      </NavCtn>

      {showLogout ? (
        <DialogLogout>
          <BtnOptionsCtn>
            <BtnCtn>
              <ButtonSmall
                isSecondary
                handleClick={(e): void => {
                  e.preventDefault();
                  setShowLogout(false);
                  deleteUserRelatedState();
                  navigate('/');
                }}
              >
                YES
              </ButtonSmall>
            </BtnCtn>
            <BtnCtn>
              <ButtonSmall
                isPrimary
                handleClick={(e): void => {
                  e.preventDefault();
                  setShowLogout(false);
                }}
              >
                NO
              </ButtonSmall>
            </BtnCtn>
          </BtnOptionsCtn>
        </DialogLogout>
      ) : (
        <React.Fragment />
      )}

      <NavdropDown active={showNavDropdown}>
        <NavdropDownTab onClick={(e):void => {
          e.preventDefault();
          openSharepoint();
        }}>
          <ICONS.externalLink />
          <span>SHAREPOINT</span>
        </NavdropDownTab>
        <NavdropDownDivider />
        <NavdropDownTab
          onClick={(e): void => {
            e.preventDefault();
            setAppPageDetails('home');
            setNavDropdown(false);
            navigate('/app/selectContract');
          }}
        >
          <ICONS.user />
          <span>SWITCH SITE</span>
        </NavdropDownTab>
        <NavdropDownDivider />
        <NavdropDownTab
          onClick={(e): void => {
            e.preventDefault();
            setShowLogout(true);
          }}
        >
          <ICONS.logOut />
          <span>LOG OUT</span>
        </NavdropDownTab>
      </NavdropDown>

      {userPermissionsList.includes('log-a-job') && currentPage != 'logJob' && currentPage != 'selectContract' &&<LogAJobBtnMobileCtn
        onClick={(e): void => {
          e.preventDefault();
          setNav('logJob');
          setAppPageDetails('logJob');
        }}
      >
        <div>
          <span>LOG A JOB</span>
        </div>
      </LogAJobBtnMobileCtn>}
    </React.Fragment>
  );
};

export default Nav;
